<template>
  <div class="app-main">
    <home-header></home-header>
    <div class="app-body">
      <section>
        <transition name="fade-transform" mode="out-in">
          <keep-alive exclude="Tools">
            <router-view />
          </keep-alive>
        </transition>
      </section>
    </div>
  </div>
</template>
<script>
import HomeHeader from "./components/HomeHeader";
export default {
  name: "Layout",
  components: {
    HomeHeader,
  },
};
</script>
<style lang="less" scoped>
.app-main {
  background: rgba(249, 251, 255, 1);
  height: 100%;
  min-width: 1000px;
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.app-body {
  height: 100%;
  section {
    // background-color: #ffffff;
    height: 100%;
    // margin: 16px;

    // box-shadow: 0 0px 10px rgba(0, 0, 0, 0.15);

    overflow-y: auto;
  }
}
</style>
